import { createLink, LinkComponent } from '@tanstack/react-router';
import { forwardRef } from 'react';

const BasicLink = forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>(function BasicLink(props, ref) {
  // Remove aria-current attribute to avoid conflict with PTabsBar attributes and its animation
  // See: PAIM-4188
  const { 'aria-current': _ariaCurrent, ...rest } = props;

  return <a ref={ref} {...rest} />;
});

const CreatedLinkComponent = createLink(BasicLink);

export const TabsBarLink: LinkComponent<typeof BasicLink> = (props) => (
  <CreatedLinkComponent {...props} />
);
